export default __webpack_public_path__ + "static/media/SVCBL-TOP-UP-CONTEST.d3558693.png";